module.exports = {"210213001":"拥政街道","210213002":"友谊街道","210213003":"光明街道","210213004":"马桥子街道","210213005":"海青岛街道","210213006":"大孤山街道","210213007":"中长街道","210213008":"站前街道","210213009":"先进街道","210213011":"董家沟街道","210213012":"金石滩街道","210213013":"湾里街道","210213014":"二十里堡街道","210213016":"亮甲店街道","210213017":"登沙河街道","210213019":"大魏家街道","210213020":"杏树街道","210213021":"七顶山街道","210213022":"华家街道","210213023":"向应街道","210213024":"大李家街道","210213025":"得胜街道","210213026":"大窑湾街道","210213027":"炮台街道","210213028":"复州湾街道","210213029":"三十里堡街道","210213030":"石河街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210213.json
// module id = 519
// module chunks = 0